import React from 'react';
import { useTheme } from '@mui/material';
import { useCountUp } from './motion';

/** Score ring: passed of total checks. */
const HealthRing = ({ passed = 0, total = 0, size = 112 }) => {
  const theme = useTheme();
  const c = 2 * Math.PI * 50;
  const share = useCountUp(total ? passed / total : 0, 900);
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" role="img" aria-label={`${passed} of ${total} checks OK`}>
      <circle cx="60" cy="60" r="50" fill="none" stroke={theme.palette.divider} strokeWidth="12" />
      <circle cx="60" cy="60" r="50" fill="none" stroke={share >= 0.8 ? theme.palette.success.main : share >= 0.5 ? '#2a9d8f' : theme.palette.warning.main}
        strokeWidth="12" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - share)} transform="rotate(-90 60 60)" />
      <text x="60" y="58" textAnchor="middle" fontSize="26" fontWeight="800" fill={theme.palette.text.primary}>{`${passed}/${total}`}</text>
      <text x="60" y="78" textAnchor="middle" fontSize="11" fill={theme.palette.text.secondary}>checks OK</text>
    </svg>
  );
};

export default HealthRing;
